const MONTHS = {
    jan: 1,
    january: 1,
    feb: 2,
    february: 2,
    mar: 3,
    march: 3,
    apr: 4,
    april: 4,
    may: 5,
    jun: 6,
    june: 6,
    jul: 7,
    july: 7,
    aug: 8,
    august: 8,
    sep: 9,
    sept: 9,
    september: 9,
    oct: 10,
    october: 10,
    nov: 11,
    november: 11,
    dec: 12,
    december: 12,
};

const MONTH_PATTERN = Object.keys(MONTHS).join('|');
const SHORT_MONTH_YEAR_PATTERN = new RegExp(
    `\\b(?:${MONTH_PATTERN})\\.?\\s*[-_/,. ]*\\s*(\\d{2})\\b|\\b(\\d{2})\\s*[-_/,. ]*\\s*(?:${MONTH_PATTERN})\\.?\\b`,
    'i'
);
const MONTH_YEAR_PATTERN = new RegExp(
    `\\b(?:${MONTH_PATTERN})\\.?\\s*[-_/,. ]*\\s*((?:19|20)\\d{2})\\b|\\b((?:19|20)\\d{2})\\s*[-_/,. ]*\\s*(?:${MONTH_PATTERN})\\.?\\b`,
    'i'
);
const NUMERIC_YEAR_MONTH_PATTERN = /\b((?:19|20)\d{2})\s*[-_/]\s*(0?[1-9]|1[0-2])\b|\b(0?[1-9]|1[0-2])\s*[-_/]\s*((?:19|20)\d{2})\b/;
const YEAR_PATTERN = /\b((?:19|20)\d{2})\b/;
const normalizeShortYear = (year) => {
    const value = Number(year);
    return value <= 69 ? 2000 + value : 1900 + value;
};

const cleanSubject = (name) => name
    .replace(new RegExp(MONTH_YEAR_PATTERN.source, 'ig'), ' ')
    .replace(new RegExp(SHORT_MONTH_YEAR_PATTERN.source, 'ig'), ' ')
    .replace(new RegExp(NUMERIC_YEAR_MONTH_PATTERN.source, 'g'), ' ')
    .replace(YEAR_PATTERN, ' ')
    .replace(/[-_/,.]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const getReportSortValues = (documentName = '') => {
    const name = String(documentName);
    const monthYearMatch = name.match(MONTH_YEAR_PATTERN);
    const shortMonthYearMatch = name.match(SHORT_MONTH_YEAR_PATTERN);
    const numericMatch = name.match(NUMERIC_YEAR_MONTH_PATTERN);
    const yearMatch = name.match(YEAR_PATTERN);

    let year;
    let month;

    if (monthYearMatch) {
        const matchedMonth = monthYearMatch[0].match(new RegExp(MONTH_PATTERN, 'i'))?.[0]?.toLowerCase();
        year = Number(monthYearMatch[1] || monthYearMatch[2]);
        month = MONTHS[matchedMonth];
    } else if (shortMonthYearMatch) {
        const matchedMonth = shortMonthYearMatch[0].match(new RegExp(MONTH_PATTERN, 'i'))?.[0]?.toLowerCase();
        year = normalizeShortYear(shortMonthYearMatch[1] || shortMonthYearMatch[2]);
        month = MONTHS[matchedMonth];
    } else if (numericMatch) {
        year = Number(numericMatch[1] || numericMatch[4]);
        month = Number(numericMatch[2] || numericMatch[3]);
    } else if (yearMatch) {
        year = Number(yearMatch[1]);
        month = 0;
    }

    return {
        subject: cleanSubject(name) || name.trim(),
        year: year || Number.MAX_SAFE_INTEGER,
        month: month || 0,
        name,
    };
};

// Groups matching report subjects together, then orders their dated versions oldest to newest.
export const sortDocumentsBySubjectAndReportDate = (documents = []) => [...documents].sort((first, second) => {
    const firstValues = getReportSortValues(first?.DOCUMENT_NAME);
    const secondValues = getReportSortValues(second?.DOCUMENT_NAME);

    const subjectOrder = firstValues.subject.localeCompare(secondValues.subject, undefined, {
        numeric: true,
        sensitivity: 'base',
    });
    if (subjectOrder !== 0) return subjectOrder;

    if (firstValues.year !== secondValues.year) return firstValues.year - secondValues.year;
    if (firstValues.month !== secondValues.month) return firstValues.month - secondValues.month;

    return firstValues.name.localeCompare(secondValues.name, undefined, {
        numeric: true,
        sensitivity: 'base',
    });
});

// Orders all dated documents globally by report date, then puts undated names last.
export const sortDocumentsByReportDate = (documents = []) => [...documents].sort((first, second) => {
    const firstValues = getReportSortValues(first?.DOCUMENT_NAME);
    const secondValues = getReportSortValues(second?.DOCUMENT_NAME);

    const firstHasDate = firstValues.year !== Number.MAX_SAFE_INTEGER;
    const secondHasDate = secondValues.year !== Number.MAX_SAFE_INTEGER;
    if (firstHasDate !== secondHasDate) return firstHasDate ? -1 : 1;
    if (firstValues.year !== secondValues.year) return secondValues.year - firstValues.year;
    if (firstValues.month !== secondValues.month) return secondValues.month - firstValues.month;

    const subjectOrder = firstValues.subject.localeCompare(secondValues.subject, undefined, {
        numeric: true,
        sensitivity: 'base',
    });
    if (subjectOrder !== 0) return subjectOrder;

    return firstValues.name.localeCompare(secondValues.name, undefined, {
        numeric: true,
        sensitivity: 'base',
    });
});
